import req from '@/api/httpRequest'
import { defineStore } from 'pinia'
import { debounce } from 'lodash'

export const useDashboardStore = defineStore('dashboardData', () => {
  const tickets = ref([])
  const closedTicketTimeout = ref(600) // ToDo: 600/null/0?

  const sortedTickets = computed(() => {
    return [...tickets.value].sort((a, b) => {
      const orderDiff = b.front_order - a.front_order
      if (orderDiff) {
        return orderDiff // front_order - по убыванию
      }

      return a.front_last_change - b.front_last_change // front_last_change - по возрастанию
    })
  })

  // BEGIN: webSocket DashBoard Updates
  const pendingUpdates = new Map()

  const processUpdates = () => {
    const updates = Array.from(pendingUpdates.values())

    tickets.value = tickets.value
      .map((t) => {
        const update = updates.find(u => u.id === t.id)
        return update ? { ...t, ...update } : t
      })
      .concat(updates.filter(u => !tickets.value.some(t => t.id === u.id)))

    pendingUpdates.clear()
  }

  const debouncedUpdate = debounce(processUpdates, 50) // requestAnimationFrame ?

  function handleTicketUpdate(update) {
    pendingUpdates.set(update.id, update)
    debouncedUpdate()
  }
  // END

  async function fetchDashboardData() {
    const { data } = await req.post('dashboard/disp', {})
    if (data.data) {
      tickets.value = data.data.tickets
      closedTicketTimeout.value = data.data.settings.close_timeout
    }
  }

  return {
    tickets,
    closedTicketTimeout,
    sortedTickets,
    fetchDashboardData,
    handleTicketUpdate,
  }
})

// {"fid":0,"uid":0,"gid":0,"app":"","cmd":"ticket","prm":"update","dat":{"attachment_count":0,"closed":null,"comment_count":0,"created":"2025-02-11 14:41:15","front_last_change":1739373269,"front_last_change_time":"2025-02-12 15:14:29","front_order":40,"front_prio":"urgent","front_state":"work","front_status":"normal","id":129,"message_count":19,"objects_count":0,"owned":"2025-02-11 22:47:20","subj":"тест на ВКС"}}
// {"fid":0,"uid":0,"gid":0,"app":"","cmd":"ticket","prm":"update","dat":{"attachment_count":0,"closed":null,"comment_count":0,"created":"2025-02-11 14:41:15","front_last_change":1739373269,"front_last_change_time":"2025-02-12 15:14:29","front_order":40,"front_prio":"urgent","front_state":"work","front_status":"frozen","id":129,"message_count":19,"objects_count":0,"owned":"2025-02-11 22:47:20","subj":"тест на ВКС"}}
